import React from "react";
import { Modal } from "antd";

import "./CustomModal.scss";

const CustomModal = (props) => {
  return (
    <Modal
      className={`custom-modal-container ${props.className}`}
      style={props.style}
      centered
      title={props?.title}
      open={props?.visible}
      okText={props.okButtonText || "Ok"}
      cancelText={props.cancelButtonText || "Cancel"}
      onCancel={props.onCancel}
      maskClosable={false}
      onOk={props.onOk}
      confirmLoading={props.loading}
      okButtonProps={props?.okButtonProps}
      footer={props.footer}
      closable={props?.closable}
      bodyStyle={props?.bodyStyle}
      width={props?.width}
    >
      {props.children}
    </Modal>
  );
};

export default React.memo(CustomModal);
